export function showToast(message: string, duration: number = 3) {
  const popover = document.createElement('div');
  popover.innerHTML = message;
  popover.classList.add('mo-message');

  document.body.appendChild(popover);

  setTimeout(() => {
    popover.remove();
  }, duration * 1000);
}
